module.exports = __webpack_public_path__ + "static/media/flytebrygge.e88571ad.png";